module.exports = __webpack_public_path__ + "static/media/card.67c71daa.svg";